<template>
	<article class="award-product-list--page">
		<ManagingSection>
			<ManagingBox title="어워드 선택">
				<select class="select" @change="changeAward" v-model="award">
					<option
						v-for="item in awardList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
			</ManagingBox>
		</ManagingSection>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left"></div>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						@click="excelDown"
					>
						엑셀 다운로드
					</button>
				</div>
			</template>
			<table class="table-main award-product-list__table">
				<thead>
					<tr>
						<th v-for="item in thList" :key="item">{{ item }}</th>
					</tr>
				</thead>
				<tbody v-if="noList">
					<tr>
						<td
							class="award-product-list__empty-table"
							:colspan="thList.length"
						>
							어워드 제품이 없습니다.
						</td>
					</tr>
				</tbody>
				<tbody v-else>
					<tr
						v-for="(item, idx) in productList"
						:key="`${idx}${item.idProduct}`"
					>
						<td>
							<router-link
								class="award-product-list__link"
								:to="`/product/product-inquiry/${item.idProduct}`"
								>{{ item.idProduct }}</router-link
							>
						</td>
						<td>
							<router-link
								class="award-product-list__link"
								:to="`/product/product-inquiry/${item.idProduct}`"
								>{{ item.productTitle }}</router-link
							>
						</td>
						<td>{{ item.brandTitle }}</td>
						<td>{{ item.awardCategory }}</td>
						<td>{{ item.category }}</td>
						<td>{{ item.avg }}</td>
						<td>{{ item.reviewCount }}</td>
						<td>{{ item.discontinue }}</td>
					</tr>
				</tbody>
			</table>
		</ManagingSection>
	</article>
</template>

<script>
	import util from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';

	export default {
		name: 'AwardProductList',
		components: { ManagingSection, ManagingBox },
		data() {
			const awardListFirstObj = { id: null, name: '어워드 선택' };
			return {
				thList: [
					'제품 ID',
					'제품 명',
					'브랜드 명',
					'어워드 카테고리',
					'카테고리',
					'평점',
					'리뷰건수',
					'단종여부',
				],
				awardListFirstObj,
				awardList: [awardListFirstObj],
				award: null,
				productList: [],
				noList: false,
				currAwardName: '',
				lastApiUrl: '',
			};
		},
		methods: {
			getTotalCategoryText(arr) {
				return arr.reduce((acc, item, idx) => {
					if (item) {
						acc += `${idx > 0 ? ' - ' : ''}${item}`;
					}
					return acc;
				}, '');
			},
			async getAwardList() {
				try {
					this.noList = false;
					const { data } = await this.$axiosAdmin2.get(
						'/api/products/award'
					);
					this.awardList = data.data.reduce(
						(acc, item) => {
							acc.push({
								id: item.idHitProducts,
								name: item.hitText,
							});
							return acc;
						},
						[this.awardListFirstObj]
					);
				} catch (err) {
					console.error(err);
					alert(
						'어워드 리스트 불러오기에 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async getProductList(id) {
				try {
					this.noList = false;
					const { config, data } = await this.$axiosAdmin2.get(
						`/api/award/products/${id}`
					);
					this.lastApiUrl = config.url;
					this.productList = data.product_list.map(item => ({
						idProduct: item.idProduct,
						productTitle: item.productTitle,
						brandTitle: item.brandTitle,
						awardCategory: this.getTotalCategoryText([
							item.hit_category1,
							item.hit_category2,
							item.hit_category3,
						]),
						category: this.getTotalCategoryText([
							item.firstCategoryText,
							item.secondCategoryText,
							item.thirdCategoryText,
						]),
						avg: item.ratingAvg ?? '',
						reviewCount: util.currency(
							(Number(item.reviewCount) || 0).toFixed(0)
						),
						discontinue: item.isDiscontinue ? '단종' : '',
					}));
					this.currAwardName = this.awardList.filter(
						item => item.id === this.award
					)[0].name;
					if (this.award !== null && this.productList.length === 0) {
						this.noList = true;
					}
				} catch (err) {
					console.error(err);
					alert(
						'어워드 상품 리스트 불러오기에 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async init() {
				this.noList = false;
				await this.getAwardList();
				const id = Number(this.$route.query.id);
				if (isNaN(id)) {
					this.award = null;
				} else {
					this.award = id;
					await this.getProductList(id);
				}
			},
			changeAward(e) {
				const value = e.target.value;
				if (value) {
					this.$router.replace({ query: { id: Number(value) } });
				}
			},
			excelDown() {
				try {
					if (this.productList.length < 1) {
						alert('데이터가 없습니다');
						return;
					}
					const rows = this.productList.map(item => [
						item.idProduct,
						item.productTitle,
						item.brandTitle,
						item.awardCategory,
						item.category,
						item.avg,
						item.reviewCount,
						item.discontinue,
					]);
					const title = `어워드별 제품 리스트 (${this.currAwardName})`;
					util.getCsv(
						[rows],
						[title],
						[this.thList],
						`글로우픽_${title}_${new Date().getTime()}`,
						this.lastApiUrl
					);
				} catch (err) {
					console.error(err);
					alert(
						'엑셀 파일을 다운로드하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
		watch: {
			'$route.query'(query) {
				this.init();
			},
		},
		created() {
			this.init();
		},
	};
</script>

<style lang="scss" scoped>
	.award-product-list--page {
		.award-product-list__table {
			th,
			td {
				text-align: left;
			}

			.award-product-list__empty-table {
				text-align: center;
			}

			.award-product-list__link {
				cursor: pointer;
				color: $font-blue;

				&:hover {
					text-decoration: underline;
				}
			}
		}
	}
</style>
